module.exports = __webpack_public_path__ + "static/media/android-ios.47871d07.png";